import Upper from "./features/Upper";
import TabNav from "./features/TabNav";
import Tab1 from "./features/Tab1";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {useReadOrderSubjects} from "./hooks/useReadOrderSubjects";
import {useReadShipmentDetail} from "./hooks/useReadShipmentDetail";
import {useForm, useWatch} from "react-hook-form";
import {
    OrdersDetailSubjectElementType,
    OrdersDetailSubjectType,
    OrdersDetailType,
    OrdersShipmentDeliveryConfirmTaxInfoType
} from "./interface";
import {
    ordersDetailInit,
    ordersDetailPtaInit,
    ordersDetailSubjectInit,
    ordersPreviousInit,
    ordersShipmentDeliveryConfirmInit
} from "./state";
import {useReadOrderPta} from "./hooks/useReadOrderPta";
import Tab3 from "./features/Tab3";
import {useReadPreviousPayment} from "./hooks/useReadPreviousPayment";
import {BasicSearchType} from "../../../../types/common/basic";
import Tab4 from "./features/Tab4";
import Tab5 from "./features/Tab5";
import Tab1Modify from "./features/Tab1Modify";
import {useSaveOrderSubjects} from "./hooks/useSaveOrderSubjects";
import {useSaveOrder} from "./hooks/useSaveOrder";
import {useModal} from "../../../../hooks";
import {useReadShipmentDeliveryConfirm} from "./hooks/useReadShipmentDeliveryConfirm";
import {useUpdateShipmentExchangeRate} from "./hooks/useUpdateShipmentExchangeRate";
import Tab2 from "./features/Tab2";
import Tab2Modify from "./features/Tab2Modify";
import {usePriceSetter} from "./hooks/usePriceSetter";
import {useReadShipmentExchangeRate} from "./hooks/useReadShipmentExchangeRate";
import {useReadExchangeType1SelectBox} from "../../../customer/correspondent/detail/hooks";

export default function OrdersDetail({isDeadline}: { isDeadline?: boolean }) {
    const {id} = useParams()
    const {handleModal} = useModal();

    const [tab, setTab] = useState("tab-1");
    const [isModify, setIsModify] = useState<"tab-1" | "tab-2" | "">("")

    const {data: ordersDetail} = useReadShipmentDetail({param: id as string})

    const {data: ordersSubjectApiData} = useReadOrderSubjects({param: id as string})
    const [ordersSubject, setOrdersSubject] = useState<OrdersDetailSubjectType>(ordersDetailSubjectInit)

    const {data: ordersPta} = useReadOrderPta({param: ordersDetail?.newLCustomerValue ?? ""})

    const [tab4SearchParam, setTab4SearchParam] =
        useState<BasicSearchType & { newLEnduserValue: string, newShipmentId: string }>({
            pageNo: 1,
            limit: 10,
            newLEnduserValue: "",
            newShipmentId: ""
        })
    const {data: ordersPrevious} = useReadPreviousPayment({
        param: tab4SearchParam,
        enabled: tab4SearchParam.newLEnduserValue !== "" && tab4SearchParam.newShipmentId !== ""
    })
    useEffect(() => {
        if (ordersDetail) {
            setTab4SearchParam({
                ...tab4SearchParam,
                newLEnduserValue: ordersDetail.newLEnduserValue,
                newShipmentId: ordersDetail.newShipmentId
            })
        }
    }, [ordersDetail]);


    const {data: ordersShipmentDeliveryConfirm} = useReadShipmentDeliveryConfirm({param: id as string})

    const closeCallback = () => setIsModify("")
    const {mutate: mutateSaveOrder} = useSaveOrder({closeCallback: closeCallback})
    const {mutate: mutateSaveOrderSubjects} = useSaveOrderSubjects({closeCallback: closeCallback})
    const {mutateAsync: mutateAsyncUpdateShipmentExchangeRate} = useUpdateShipmentExchangeRate()

    const {register, handleSubmit, getValues, control, setValue, watch} = useForm({
        defaultValues: ordersDetail,
    });

    const {
        register: registerSubject,
        getValues: getValuesSubject,
        setValue: setValueSubject,
        control: controlSubject,
        handleSubmit: handleSubmitSubject,
        watch: watchSubject
    } = useForm({
        defaultValues: ordersSubject,
    })

    const watchUpdateDetail = {
        ...ordersDetail,
        ...useWatch<OrdersDetailType>({control}),
    } as OrdersDetailType

    const watchUpdateSubject = {
        ...ordersSubject,
        ...useWatch<OrdersDetailSubjectType>({control: controlSubject}),
    } as OrdersDetailSubjectType

    useEffect(() => {
        if (isModify !== "") {
            switch (tab) {
                case "tab-1":
                    if (ordersDetail) {
                        if (isModify === "tab-1") {
                            for (const ordersDetailKey in ordersDetail) {
                                setValue(ordersDetailKey, ordersDetail[ordersDetailKey as keyof OrdersDetailType])
                            }
                        }
                    }
                    break;
                case "tab-2":
                    if (ordersSubject) {
                        if (isModify === "tab-2") {
                            setValueSubject("newShipmentId", ordersSubject.newShipmentId)
                            setValueSubject("exchangeRateCondition1", ordersSubject.exchangeRateCondition1)
                            setValueSubject("exchangeRateCondition2", ordersSubject.exchangeRateCondition2)
                            setValueSubject("exchangeRateCondition3", ordersSubject.exchangeRateCondition3)
                            setValueSubject("exchangeRateUnit", ordersSubject.exchangeRateUnit)
                            setValueSubject("newDExchangeRate", ordersSubject.newDExchangeRate)
                            setValueSubject("newPCurrency", ordersSubject.newPCurrency)
                            setValueSubject("list", ordersSubject.list ?? [])
                        }
                    }
                    break;
            }
        }
    }, [isModify]);

    useEffect(() => {
        if (ordersDetail && ordersDetail.taxInfo) {
            const taxInfo: OrdersShipmentDeliveryConfirmTaxInfoType = ordersDetail.taxInfo

            setValue("taxInfo", taxInfo)
        }
    }, [ordersDetail]);

    const btnTab1Save = () => {
        if (!watchUpdateDetail.newLEnduserValue || watchUpdateDetail.newLEnduserValue === "") {
            handleModal({
                isOpen: true,
                contents: "고객사를 선택해주세요.",
                type: "alert",
            })
        } else if (!watchUpdateDetail.newLContactValue || watchUpdateDetail.newLContactValue === "") {
            handleModal({
                isOpen: true,
                contents: "수주고객을 선택해주세요.",
                type: "alert",
            })
        } else if (!watchUpdateDetail.owneridValue || watchUpdateDetail.owneridValue === "") {
            handleModal({
                isOpen: true,
                contents: "담당자를 선택해주세요.",
                type: "alert",
            })
        } else if (!watchUpdateDetail.newPShipment || watchUpdateDetail.newPShipment === 0) {
            handleModal({
                isOpen: true,
                contents: "발송방법을 선택해주세요.",
                type: "alert",
            })
        } else if (!watchUpdateDetail._new_l_recipient_value || watchUpdateDetail._new_l_recipient_value === "") {
            handleModal({
                isOpen: true,
                contents: "수신자를 선택해주세요.",
                type: "alert",
            })
        } else if (!watchUpdateDetail.newDtOrder || watchUpdateDetail.newDtOrder === "") {
            handleModal({
                isOpen: true,
                contents: "수주일자를 입력해주세요.",
                type: "alert",
            })
        } else if (!watchUpdateDetail.newLShipToValue || watchUpdateDetail.newLShipToValue === "") {
            handleModal({
                isOpen: true,
                contents: "납품처를 선택해주세요.",
                type: "alert",
            })
        } else if (!watchUpdateDetail.newLCustomerValue || watchUpdateDetail.newLCustomerValue === "") {
            handleModal({
                isOpen: true,
                contents: "매출처를 선택해주세요.",
                type: "alert",
            })
        } else if (!watchUpdateDetail.newDtOrder || watchUpdateDetail.newDtOrder === "") {
            handleModal({
                isOpen: true,
                contents: "수주일자를 입력해주세요.",
                type: "alert",
            })
        } else if (!watchUpdateDetail._new_l_order_type_m_value || watchUpdateDetail._new_l_order_type_m_value === "") {
            handleModal({
                isOpen: true,
                contents: "수주 유형을 선택해주세요.",
                type: "alert",
            })
        } else if (!watchUpdateDetail._new_l_vat_value || watchUpdateDetail._new_l_vat_value === "") {
            handleModal({
                isOpen: true,
                contents: "Vat 구분을 선택해주세요.",
                type: "alert",
            })
        } else if (!watchUpdateDetail.newLIndustryValue || watchUpdateDetail.newLIndustryValue === "") {
            handleModal({
                isOpen: true,
                contents: "산업 구분을 선택해주세요.",
                type: "alert",
            })
        } else if (!watchUpdateDetail.newLApplicationValue || watchUpdateDetail.newLApplicationValue === "") {
            handleModal({
                isOpen: true,
                contents: "Application을 선택해주세요.",
                type: "alert",
            })
        } else if (!watchUpdateDetail.newDtEstimatedCollection || watchUpdateDetail.newDtEstimatedCollection === "") {
            handleModal({
                isOpen: true,
                contents: "수금예정일을 입력해주세요.",
                type: "alert",
            })
        } else if (!watchUpdateDetail.newPPayment || watchUpdateDetail.newPPayment === 0) {
            handleModal({
                isOpen: true,
                contents: "결제방법을 선택해주세요.",
                type: "alert",
            })
        } else if (!watchUpdateDetail.newLInvoiceAgentValue || watchUpdateDetail.newLInvoiceAgentValue === "") {
            handleModal({
                isOpen: true,
                contents: "계산서 담당자를 선택해주세요.",
                type: "alert",
            })
        } else {
            mutateSaveOrder(watchUpdateDetail)
        }
    };

    const {
        applyCurrencyValue,
        isNanSumValue,
        sumValue
    } = usePriceSetter(watchUpdateSubject.wonUnit, watchUpdateSubject.newDExchangeRate)
    const btnTab2Save = () => {
        if (!watchUpdateSubject.exchangeRateCondition2 || !watchUpdateSubject.exchangeRateCondition3 || !watchUpdateSubject.exchangeRateUnit) {
            handleModal({
                isOpen: true,
                contents: "환율 지정 조건이 없습니다.",
                type: "alert"
            })
        } else {
            const param = {
                ...watchUpdateSubject,
                list: watchUpdateSubject.list.map((el: OrdersDetailSubjectElementType) => ({
                    ...el,
                    new_d_won: applyCurrencyValue(el.new_d_unitprice) * Number(el.new_i_qty),
                    new_d_total: Number(el.new_d_unitprice) * Number(el.new_i_qty)
                }))
            }

            mutateAsyncUpdateShipmentExchangeRate(param).then((res) => {
                if (res.data.code === "0000") {
                    mutateSaveOrderSubjects(param.list)
                } else {
                    handleModal({
                        isOpen: true,
                        contents: (res.data as any).message ?? "",
                        type: "alert",
                    });
                }
            }).catch((e: Error) => {
                if (e.message) {
                    handleModal({
                        isOpen: true,
                        contents: e.message,
                        type: "alert",
                    });
                }
            })
        }
    }

    const btnToggleModify = (key: "tab-1" | "tab-2" | "") => {
        if (key === isModify && key !== "") {
            setIsModify("")
        } else {
            setIsModify(key)
        }
    }

    const {data: exchangeTypeSelect1} = useReadExchangeType1SelectBox();
    const {mutateAsync: mutateAsyncReadShipmentExchangeRate} = useReadShipmentExchangeRate()

    useEffect(() => {
        if (ordersSubjectApiData) {
            setOrdersSubject(ordersSubjectApiData)
        }
    }, [ordersSubjectApiData]);

    useEffect(() => {
        if (ordersSubject.newShipmentId !== "" && ordersSubject.newDExchangeRate === 0) {
            const param = {
                exchangeReq: {
                    endAt: ordersSubject?.endAt,
                    startAt: ordersSubject?.startAt,
                    keywordType: ordersSubject?.exchangeRateCondition2 ?? "",
                    keywordType2: ordersSubject?.exchangeRateCondition1 ?? "",
                    keywordType2Name: exchangeTypeSelect1?.find(el => el.id == ordersSubject?.exchangeRateCondition1)?.name ?? "",
                },
                rateType: ordersSubject?.exchangeRateCondition3 ? String(ordersSubject?.exchangeRateCondition3) : null,
                regionType: ordersSubject?.newPCurrency ? String(ordersSubject?.newPCurrency) : null,
                showType: ordersSubject?.exchangeRateUnit ? String(ordersSubject?.exchangeRateUnit) : null
            }

            mutateAsyncReadShipmentExchangeRate(param).then(res => {
                if (res?.data?.code !== "0000") {
                    handleModal({
                        isOpen: true,
                        contents: res?.data?.msg,
                        type: "alert",
                    });
                } else {
                    setValue("newDExchangeRate", res.data.result ?? 0)
                    setOrdersSubject({...ordersSubject, newDExchangeRate: res.data.result ?? 0})
                }
            })
        }
    }, [ordersSubject]);

    return <>
        <Upper ordersDetail={ordersDetail ?? ordersDetailInit}
               isModify={isModify}
               tab={tab}
               btnToggleModify={() => btnToggleModify("tab-1")}
               btnSave={btnTab1Save}
               isDeadline={isDeadline}/>

        <TabNav tab={tab}
                setTab={setTab}
                ordersDetail={ordersDetail ?? ordersDetailInit}
                isModify={isModify}
                isDeadline={isDeadline}/>

        {tab === "tab-1" && (isModify === ""
            ? <Tab1 ordersDetail={ordersDetail ?? ordersDetailInit}/>
            : <Tab1Modify watchUpdateDetail={watchUpdateDetail}
                          register={register}
                          setValue={setValue}/>)}

        {tab === "tab-2" && (isModify === ""
                ? <Tab2 ordersSubject={ordersSubject}
                        btnToggleModify={() => btnToggleModify("tab-2")}
                        wonUnit={watchSubject("wonUnit")}
                        register={registerSubject}
                        isDeadline={isDeadline}/>
                : <Tab2Modify watchUpdateSubject={watchUpdateSubject}
                              btnSave={btnTab2Save}
                              btnToggleModify={() => btnToggleModify("tab-2")}
                              isModify={isModify}
                              wonUnit={watchSubject("wonUnit")}
                              register={registerSubject}
                              getValues={getValuesSubject}
                              setValue={setValueSubject}
                              isDeadline={isDeadline}
                              ordersDetail={ordersDetail ?? ordersDetailInit}
                              control={controlSubject}/>
        )}

        {tab === "tab-3" && <Tab3 ordersPta={ordersPta ?? ordersDetailPtaInit}/>}

        {tab === "tab-4" && <Tab4 ordersPrevious={ordersPrevious ?? ordersPreviousInit}
                                  searchParam={tab4SearchParam}
                                  setSearchParam={setTab4SearchParam}/>}

        {tab === "tab-5" &&
            <Tab5 ordersShipmentDeliveryConfirm={ordersShipmentDeliveryConfirm ?? ordersShipmentDeliveryConfirmInit}
                  isDeadline={isDeadline}/>}
    </>
}